/** Føroyskt. */
export default {
  header: {
    features: 'Funktiónir',
    pricing: 'Prísir',
    contact: 'Samband',
    getStarted: 'Byrja',
    login: 'Rita inn',
  },

  footer: {
    description: 'Ein pallur til limir, útleigu av løkum, tiltøk og roknskap, ætlaður feløgum.',
    product: 'Vøra',
    help: 'Hjálp',
    legal: 'Løgfrøði',
    features: 'Funktiónir',
    pricing: 'Prísir',
    getStarted: 'Byrja',
    contactUs: 'Set teg í samband',
    privacy: 'Privatlív',
    terms: 'Treytir',
    copyright: 'Øll rættindi eru vard.',
  },

  home: {
    unknownTenant:
      'Einki virkið felag varð funnið á {host}. Er felagið júst stovnað, kann tað taka nakrar minuttir, áðrenn síðan er klár - royn at endurlesa síðuna um eina løtu. Ert tú í iva um adressuna, ella heldur trupulleikin fram, so',
    unknownTenantHere: 'hesi adressu',
    unknownTenantContact: 'set teg í samband við okkum',
    heroTitlePre: 'Ger títt felag talgilt við',
    heroSubtitle: 'Ein pallur til limir, útleigu av løkum, tiltøk og roknskap, ætlaður feløgum.',
    ctaFree: 'Byrja ókeypis',
    learnMore: 'Les meira',
    featuresTitle: 'Tað tú hevur brúk fyri at reka felagið',
    featuresSubtitle: 'Amboðini savnað á einum palli',
    features: [
      { icon: '👥', title: 'Limaskrá', desc: 'Limir, limaskapur og húsarhald, við rokning tá limaskapur verður endurnýggjaður.' },
      { icon: '🏠', title: 'Útleiga av løkum', desc: 'Bókingar við prísum, sáttmála, trygd og rokning.' },
      { icon: '📅', title: 'Tiltøk', desc: 'Seðlasøla við rúmd og QR-kota við hurðina.' },
      { icon: '💳', title: 'Rokningar og gjald', desc: 'Rokningar og kreditrokningar, og gjald við korti og Vipps gjøgnum Nets.' },
      { icon: '📧', title: 'Teldupostur og SMS', desc: 'Váttanir, áminningar, rokningar og seðlar verða sendir av sær sjálvum.' },
      { icon: '🌐', title: 'Egin heimasíða', desc: 'Egin síða felagsins við síðum, tíðindum og egnum útsjónd.' },
    ],
    stepsTitle: 'Soleiðis kemur tú í gongd',
    steps: [
      { num: 1, title: 'Send eina umbøn', desc: 'Fortel okkum um felagið, so seta vit síðuna hjá tykkum upp.' },
      { num: 2, title: 'Set upp', desc: 'Legg løkur, limaskaparsløg og prísir inn.' },
      { num: 3, title: 'Tak í nýtslu', desc: 'Tak ímóti bókingum, selj seðlar og send rokningar.' },
    ],
    ctaTitle: 'Klár/ur at gera felagslívið einfaldari?',
    ctaText: 'Byrja ókeypis í dag. Eingin bindingartíð.',
    ctaButton: 'Byrja ókeypis',
    heroImageAlt: 'Yvirlitið í umsitingini hjá einum sýnisfelag',
  },

  features: {
    heroTitle: 'Sterkar funktiónir til títt felag',
    heroSubtitle: 'Limir, útleiga, tiltøk, rokningar og roknskapur á einum palli.',
    list: [
      {
        icon: '👥',
        title: 'Limastýring',
        description: 'Limir, limaskapur og húsarhald á einum stað.',
        details: [
          'Limaskaparsløg og húsarhald við børnum',
          'Endurnýggjan við rokning',
          'Sjálvboðið arbeiði og tímar',
        ],
      },
      {
        icon: '🏠',
        title: 'Útleiga av løkum',
        description: 'Tak ímóti og fylg bókingum upp.',
        details: [
          'Prísir, tilløg og halgidagar',
          'Sáttmáli sum verður undirskrivaður á netinum',
          'Trygd og rokning',
        ],
      },
      {
        icon: '📅',
        title: 'Tiltøk',
        description: 'Selj seðlar og slepp røttum fólki inn.',
        details: [
          'Seðlasøla við rúmd',
          'Seðlasløg í røð, til dømis early bird og sølu við hurðina',
          'QR-kota við hurðina',
        ],
      },
      {
        icon: '💳',
        title: 'Rokningar og gjald',
        description: 'Rokningar og kreditrokningar, og kortgjald.',
        details: ['Rokning við áminning', 'Kort og Vipps gjøgnum Nets', 'Roknskapur og kontoplan'],
      },
      {
        icon: '📧',
        title: 'Samskifti',
        description: 'Boð verða send av sær sjálvum á røttum tíð.',
        details: ['Teldupostur og SMS', 'Fyrimyndir á fleiri málum', 'Fráboðanir á røttum tíð'],
      },
      {
        icon: '🌐',
        title: 'Egin heimasíða',
        description: 'Egin síða felagsins við síðum og tíðindum.',
        details: ['Síður og tíðindi', 'Trý útsjónd og egnir litir', 'Egið økisnavn (vit seta tað upp)'],
      },
      {
        icon: '🔐',
        title: 'Trygd og persónsvernd',
        description: 'Hvørt felag er avmarkað frá hinum.',
        details: [
          'Tvífaktor-innskráning',
          'Dátur verða goymdar í Noregi',
          'Innlit, útflutningur og striking av persónsupplýsingum',
        ],
      },
    ],
    ctaTitle: 'Klár/ur at byrja?',
    ctaText: 'Byrja ókeypis í dag og upplivi, hvussu einfalt tað kann vera at reka eitt felag.',
    ctaButton: 'Byrja ókeypis',
    screensTitle: 'Soleiðis sær tað út',
    screensSubtitle: 'Skermmyndir frá einum sýnisfelag við uppfunnum dátum. Umsitingin er á norskum.',
    screens: [
      { title: 'Yvirlit', text: 'Tað, sum skal fylgjast upp, og hvat sum er framman fyri, á einari síðu.' },
      { title: 'Bókingar', text: 'Umbønir, váttanir og støðan á øllum bókingum.' },
      { title: 'Kalendari', text: 'Gestir síggja, nær løkurnar eru leysar, og hvat sum hendir í húsinum.' },
      { title: 'Seðlar', text: 'Søla eftir seðlasløgum, luttakarar og innritan.' },
      { title: 'Vel sess', text: 'Keyparin velur sær sess á korti av løkuni.' },
      { title: 'Salskort', text: 'Drag borð, stólar, pall og bar inn á kortið, við grundteikning aftanfyri.' },
      { title: 'Limaskapur', text: 'Limir, limaskaparsløg og húsarhald.' },
      { title: 'Rokningar', text: 'Rokningar og kreditrokningar við støðu, gjaldsdegi og útistandandi.' },
      { title: 'Í telefonini', text: 'Heimasíða felagsins virkar í telefon.' },
    ],
  },

  pricing: {
    heroTitle: 'Einfaldur og gjøgnumskygdur prísur',
    heroSubtitle: 'Vel ta ætlan, sum hóskar til felagið hjá tær.',
    loading: 'Heinti prísir...',
    loadError: 'Fekk ikki heintað dagførdar prísir. Vísi goymdar prísir.',
    popular: 'Mest umtókt',
    perMonth: 'kr/mnð',
    unlimited: 'Óavmarkað',
    unlimitedMembers: 'Óavmarkað tal av limum',
    upToMembers: 'Upp til {count} limir',
    prioritySupport: 'Raðfest stuðul: vit byrja innan 30 minuttir, gerandisdagar 9–15',
    planDescFree: 'Til smá feløg',
    planDescStandard: 'Til virkin feløg',
    planDescAdvanced: 'Til stórar felagsskapir',
    ctaFree: 'Byrja ókeypis',
    ctaTrial: 'Send eina umbøn',
    faqTitle: 'Ofta settar spurningar',
    faq: [
      { q: 'Kann eg skifta skipan, nær tað skal vera?', a: 'Ja, set teg í samband við okkum, so skifta vit ætlanina.' },
      { q: 'Hvat hendir, um vit fara um markið fyri limir?', a: 'Vit seta okkum í samband og avtala eina uppgraderan. Einki verður stongt, uttan at vit hava talað við tykkum.' },
      { q: 'Er nøkur bindingartíð?', a: 'Nei, allar skipanir kunnu sigast upp, nær tað skal vera.' },
      { q: 'Bjóða tit avsláttir til vælgerandi feløg?', a: 'Ja, set teg í samband við okkum fyri serligar prísir til vælgerandi feløg.' },
      { q: 'Hvat kostar kortgjald?', a: 'Kort og Vipps ganga gjøgnum Nets. Felagið hevur eina egna avtalu við Nets og rindar gjaldið beinleiðis til tey.' },
    ],
    emailSms: 'Teldupostur og SMS',
    bookingsPerMonth: '{count} bókingar um mánaðin',
    unlimitedBookings: 'Ótakmarkaðar bókingar',
    ticketsPerMonth: '{count} seðlar um mánaðin',
    unlimitedTickets: 'Ótakmarkaðir seðlar',
    locations: 'Upp til {count} løkur',
    unlimitedLocations: 'Ótakmarkaðar løkur',
    storage: '{size} goymsla',
    customBranding: 'Egið útsjónd og egnir litir',
    exportCsv: 'Útflutningur til CSV',
    introNotice:
      'Í eini byrjanartíð eru allar ætlanir ókeypis. Vit boða frá í minsta lagi 30 dagar áðrenn rokning byrjar.',
  },

  contact: {
    heroTitle: 'Set teg í samband',
    heroSubtitle: 'Vit eru her fyri at hjálpa. Skriva til okkara, so svara vit so skjótt vit kunnu.',
    formTitle: 'Skriva til okkara',
    formIntro:
      'Hevur tú spurningar um CommunityNord, prísir ella hvussu vit kunnu hjálpa felagnum hjá tær? Fyll út skjalið, ella send okkum eitt teldupost.',
    email: 'Teldupostur',
    name: 'Navn',
    organization: 'Felag/Felagsskapur',
    subject: 'Evni',
    chooseSubject: 'Vel evni',
    subjectGeneral: 'Alment spurdómur',
    subjectPricing: 'Prísir og hald',
    subjectSupport: 'Tøknilig hjálp',
    subjectDemo: 'Bið um framsýning',
    subjectPartnership: 'Samstarv',
    message: 'Boð',
    send: 'Send boð',
    success:
      'Takk! Vit hava móttikið boðini hjá tær og seta okkum í samband so skjótt vit kunnu.',
    error: 'Okkurt gekk skeivt. Royn aftur, ella send okkum eitt teldupost.',
    tooMany: 'Tú hevur sent nógv boð. Royn aftur seinni, ella send okkum eitt teldupost.',
    sending: 'Sendi...',
    supportNote:
      'Standard og Avansert hava raðfestan stuðul: vit byrja á málinum innan 30 minuttir, gerandisdagar 9–15.',
  },

  login: {
    title: 'Rita inn',
    subtitle:
      'Hvørt felag hevur sína egnu innritan. Skriva adressu felagsins, so fara vit við tær har.',
    label: 'Adressa felagsins',
    placeholder: 'felagid',
    button: 'Far til innritan',
    hint:
      'Hevur felagið egið økisnavn, brúkar tú tað í staðin. Finnur tú ikki adressuna, spyr stjórnina ella set teg í samband við okkum.',
    invalid: 'Brúka bert lítlar bókstavir, tøl og bindistrik.',
  },

  signup: {
    heroTitle: 'Byrja við CommunityNord',
    heroSubtitle:
      'Fyll oyðublaðið út fyri at stovna eitt nýtt felag. Vit senda tær ein teldupost, tá kontan er klár.',
    formTitle: 'Stovna nýtt felag',
    success:
      'Takk fyri áheitanina! Vit hava móttikið umbønina og seta okkum í samband, so skjótt kontan er klár.',
    error:
      'Ein villa hendi, tá sent varð. Vinarliga royn aftur ella set teg í samband við okkum.',
    orgName: 'Navn á felag',
    orgNamePlaceholder: 'Navn felagsins',
    contactPerson: 'Sambandspersónur',
    contactPersonPlaceholder: 'Títt fulla navn',
    email: 'Teldupostur',
    phone: 'Telefon',
    plan: 'Ynskt hald',
    messageOptional: 'Boð (valfrítt)',
    messagePlaceholder: 'Sig okkum eitt sindur um títt felag...',
    sending: 'Sendi...',
    submit: 'Send umbøn',
    free: 'Ókeypis',
    perMonth: 'kr/mnð',
    upTo50: 'Upp til 50 limir',
    upTo500: 'Upp til 500 limir',
    unlimitedMembers: 'Óavmarkað tal av limum',
    nextTitle: 'Hvat hendir nú?',
    nextSteps: [
      { title: 'Umbøn send', desc: 'Vit móttaka tína umbøn og senda váttan til tín teldupost.' },
      { title: 'Viðgerð', desc: 'Okkara toymi viðger umbønina, vanliga innan 1-2 gerandisdagar.' },
      { title: 'Vælkomin', desc: 'Tú fært eitt boðslag í telduposti til at stovna tína kontu.' },
    ],
    questionsTitle: 'Spurningar?',
    questionsContact: 'Set teg í samband við okkum á',
  },

  onboarding: {
    homeTitle: 'CommunityNord uppseting',
    homeSubtitle:
      'Fyri at stovna eitt nýtt felag tørvar tær eitt boðslag. Set teg í samband við ein umsitara fyri at fáa tað sent.',
    homeGotLink: 'Hevur tú móttikið eitt leinki?',
    homeGotLinkText:
      'Trýst á leinkið, tú hevur fingið í telduposti, fyri at byrja uppsetingina av tínum felag.',
    homeBack: '← Aftur til communitynord.com',
    validating: 'Vátti boðið...',
    invalidTitle: 'Ógyldugt boð',
    invalidContact: 'Set teg í samband við umsitaran fyri at fáa eitt nýtt boðslag.',
    connectError: 'Fekk ikki samband við ambætaran. Royn aftur seinni.',
    deviceBound:
      'Hetta leinkið er longu opnað á aðrari eind og er bundið at henni. Opna leinkið á fyrstu eindini fyri at halda fram, ella skriva til support@communitynord.com, so senda vit eitt nýtt leinki.',
    genericError: 'Okkurt gekk galið. Royn aftur.',
    steps: ['Vælkomin', 'Felag', 'Samband', 'Konta', 'Vátta'],
    step1Title: 'Vælkomin til CommunityNord',
    step1Subtitle:
      'Tú ert boðin/boðið at stovna eitt nýtt felag. Vit leiða teg gjøgnum uppsetingina stig fyri stig.',
    step1Suggested: 'Uppskot til navn:',
    step1SentTo: 'Boð sent til:',
    step1Expires: 'Boðið gongur út:',
    step1Needs: 'Hetta tørvar tær:',
    step1NeedsList: [
      'Navnið á felagnum',
      'Sambandsupplýsingar',
      'Møguligt skrásetingarnummar',
      'Ynskt brúkaranavn og loyniorð',
    ],
    step1Start: 'Byrja →',
    back: '← Aftur',
    next: 'Næsta →',
    step2Title: 'Um felagið',
    step2Subtitle: 'Sig okkum frá felagnum, sum skal brúka skipanina.',
    orgName: 'Navn á felag',
    orgNamePlaceholder: 'T.d. Ungdómshúsið í Havn',
    orgNameRequired: 'Navn á felag er kravt',
    slug: 'URL-forskoyti (slug)',
    slugRequired: 'URL-forskoyti er kravt',
    slugFormat: 'Bert smáir bókstavir, tøl og bindistrikur',
    slugMin: 'Í minsta lagi 2 tekin',
    shortName: 'Stuttnavn',
    shortNameRequired: 'Stuttnavn er kravt',
    shortNameMax: 'Í mesta lagi 10 tekin',
    shortNameFormat: 'Bert bókstavir og tøl',
    shortNameHint: 'Verður brúkt sum forskoyti í fakturanummari o.ø.',
    customDomain: 'Egið navnaøki',
    customDomainPlaceholder: 't.d. dømi.fo',
    customDomainHint: 'Valfrítt. Gevur atgongd um egið navnaøki umframt undirnavnaøkið.',
    customDomainNoProtocol: 'Skriva bert navnaøkið, uttan http:// ella https://',
    customDomainNoPath: 'Skriva bert navnaøkið, uttan leið',
    customDomainInvalid: 'Ógyldugt snið á navnaøki',
    country: 'Land',
    countryHint: 'Landið, felagið hoyrir til',
    countryNames: { NO: 'Noreg', SE: 'Svøríki', DK: 'Danmark' },
    orgNumber: 'Skrásetingarnummar',
    orgNumberHint: 'Valfrítt. Skrásetingarnummar felagsins.',
    appearance: 'Útsjónd',
    layout: 'Útsjónd á heimasíðuni',
    layoutHint: 'Kann broytast, nær tað skal vera, undir Umsiting → Búmerki.',
    layouts: [
      { key: 'classic', name: 'Klassiskt', description: 'Vanlig uppseting við miðsettum innihaldi og búmerki til vinstru. Hóskar teimum flestu.' },
      { key: 'modern', name: 'Nútímans', description: 'Forsíða í fullari breidd og samanpakkað valmynd. Ferskur og lættur stílur.' },
      { key: 'compact', name: 'Samanpakkað', description: 'Minimal luft og tættar upplýsingar. Gott til innihaldsríkar síður.' },
      { key: 'custom', name: 'Serlagað', description: 'Egin sniðgeving gjørd í samstarvi við okkum. Vit seta okkum í samband.' },
    ],
    tagline: 'Slagorð / mottó',
    taglinePlaceholder: 'T.d. „Saman skapa vit virksemi“',
    taglineHint: 'Valfrítt. Sæst í botntekstinum á heimasíðuni.',
    logo: 'Búmerki',
    logoUpload: 'Legg búmerki upp',
    logoChange: 'Skift mynd',
    logoRemove: 'Tak burtur',
    logoHint: 'Valfrítt. PNG/JPG/SVG, í mesta lagi 2 MB. Kann eisini leggjast afturat seinni.',
    logoTooBig: 'Myndin er ov stór (í mesta lagi 2 MB)',
    logoNotImage: 'Fílan má vera ein mynd',
    logoUseUrl: 'Brúka URL ístaðin',
    logoUrlPlaceholder: 'https://...',
    logoUrlHint: 'Fullfíggjað URL til búmerkið (https://...).',
    subscriptionPlan: 'Haldsskipan',
    subscriptionPlanHint:
      'Henda skipan verður sett sum byrjanarskipan og kann broytast í portalinum seinni.',
    step3Title: 'Sambandsupplýsingar',
    step3Subtitle:
      'Hvør er høvuðssambandspersónur hjá felagnum? Hesin persónur verður eigari av kontuni.',
    contactPerson: 'Sambandspersónur',
    contactPersonRequired: 'Sambandspersónur er kravdur',
    email: 'Teldupostadressa',
    emailRequired: 'Teldupostur er kravdur',
    emailInvalid: 'Ógyldug teldupostadressa',
    phone: 'Telefonnummar',
    postalAddress: 'Postadressa',
    optional: '(valfrítt)',
    streetAddress: 'Gøtuadressa',
    city: 'Býur',
    postalCode: 'Postnr.',
    sameAsPostal: 'Vitjanaradressan er tann sama sum postadressan',
    visitingAddress: 'Vitjanaradressa',
    step4Title: 'Stovna brúkarakontu',
    step4Subtitle:
      'Hesin brúkarin verður eigari av felagnum við fullari atgongd. Tú kanst leggja fleiri brúkarar afturat seinni.',
    username: 'Brúkaranavn',
    usernameRequired: 'Brúkaranavn er kravt',
    usernameMin: 'Í minsta lagi 3 tekin',
    usernameMax: 'Í mesta lagi 256 tekin',
    usernameEmailInvalid: 'Ógyldugt teldupostsnið',
    usernameFormat:
      'Brúka brúkaranavnasnið (a-z, 0-9, punkt, undirstrika, bindistriku) ella eina gylduga teldupostadressu',
    usernamePlaceholder: 'jógvan.hansen ella navn@navnaøki.fo',
    usernameHint: 'Verður brúkt til innritan. Kann vera brúkaranavn ella teldupostadressa.',
    loginEmail: 'Teldupostur (til innritan)',
    loginEmailHint: 'Heintað úr sambandsupplýsingunum í undanfarna stigi.',
    password: 'Loyniorð',
    passwordRequired: 'Loyniorð er kravt',
    passwordMin: 'Í minsta lagi 8 tekin',
    passwordShow: 'Vís',
    passwordHide: 'Fjal',
    passwordHint: 'Ráð: Brúka eina blanding av stórum/smáum bókstavum, tølum og sertekinum.',
    passwordConfirm: 'Vátta loyniorð',
    passwordConfirmPlaceholder: 'Endurtak loyniorðið',
    passwordMismatch: 'Loyniorðini eru ikki eins',
    step5Title: 'Vátta og stovna',
    step5Subtitle:
      'Hygg eftir upplýsingunum, áðrenn tú stovnar felagið. Tú kanst fara aftur fyri at gera broytingar.',
    reviewOrg: 'Felag',
    reviewName: 'Navn',
    reviewUrl: 'URL',
    reviewCustomDomain: 'Egið navnaøki',
    reviewCountry: 'Land',
    reviewShortName: 'Stuttnavn',
    reviewOrgNumber: 'Skr.nr.',
    reviewPlan: 'Hald',
    reviewLayout: 'Útsjónd',
    reviewTagline: 'Slagorð',
    reviewLogo: 'Búmerki',
    reviewContact: 'Samband',
    reviewContactPerson: 'Sambandspersónur',
    reviewEmail: 'Teldupostur',
    reviewPhone: 'Telefon',
    reviewPostal: 'Postadressa',
    reviewVisiting: 'Vitjanaradressa',
    reviewAddress: 'Adressa',
    reviewPlace: 'Býur',
    reviewAccount: 'Brúkarakonta',
    reviewUsername: 'Brúkaranavn',
    reviewPassword: 'Loyniorð',
    reviewRole: 'Leiklutur',
    reviewOwner: 'Eigari (Owner)',
    creating: 'Stovni...',
    create: 'Stovna felag ✓',
    successTitle: '{name} er stovnað!',
    successAwaiting:
      'Vit fyrireika nú heimasíðuna hjá tykkum — hetta er eitt manuelt stig, har vit tryggja, at alt er rætt sett upp. Tit fáa ein teldupost til {email}, so skjótt síðan er klár at brúka.',
    successAwaitingNoEmail:
      'Vit fyrireika nú heimasíðuna hjá tykkum — hetta er eitt manuelt stig, har vit tryggja, at alt er rætt sett upp. Tit fáa ein teldupost, so skjótt síðan er klár at brúka.',
    successWhatNow: 'Hvat hendir nú?',
    successStep1: 'Vit kanna uppsetingina og gera síðuna klára. Tað tekur vanliga stutta tíð.',
    successStep2: 'Tit fáa ein teldupost, tá síðan er klár, við leinki til innritan.',
    successStep3: 'Rita inn við brúkaranavninum {username} og loyniorðinum, tit valdu.',
    successDetails: 'Tínar upplýsingar',
    successOrg: 'Felag',
    successUrl: 'Netadressa',
    successUsername: 'Brúkaranavn',
    successDnsTitle: 'Egið navnaøki: {domain}',
    successDnsIntro:
      'Fyri at {domain} skal peika á heimasíðuna hjá tykkum, mugu DNS-stillingarnar hjá tykkara navnaøkisveitara dagførast. Vel annan av møguleikunum:',
    successDnsCnameTitle: 'Møguleiki 1 — CNAME (einfaldast)',
    successDnsCnameText: 'Stovna eina CNAME-skráseting, sum peikar á tykkara undirnavnaøki:',
    successDnsATitle: 'Møguleiki 2 — A-skráseting',
    successDnsAText: 'Peika navnaøkið beinleiðis á okkara ambætara-IP:',
    successDnsNote:
      'DNS-broytingar kunnu taka upp til nakrar tímar at koma í gildi. Gev gætur: ein CNAME kann ikki brúkast á einum rótnavnaøki (dømi.fo) hjá øllum veitarum — brúka tá eina A-skráseting, ella CNAME á www. Vit vátta navnaøkið sum part av fyrireikingini.',
    successDnsType: 'Slag',
    successDnsName: 'Navn/vertur',
    successDnsValue: 'Virði/mál',
  },
}
